import { render } from "./DuringDeliveryOrders.vue?vue&type=template&id=03061cb8"
import script from "./DuringDeliveryOrders.vue?vue&type=script&lang=js"
export * from "./DuringDeliveryOrders.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__